import React from "react";
import { Blocks } from "react-loader-spinner";

export const Loader = ({ loader }) => {
  return (
    <div className="blockLoader">
      <div className="spinner">
        <div className="spinner1"></div>
      </div>
    </div>
  );
};
export const Loader2 = ({ loader }) => {
  return (
    <div className="blockLoader2">
      <div className="loderInner">
        <div className="spinner">
          <div className="spinner1"></div>
        </div>
      </div>
    </div>
  );
};
